/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';

const Item = ({ className, module, previewImg, errors }) => {
  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description="Background colour">
      Latest News Panel
    </InfoItem.WithError>
  );
};

export default Item;
